import useApiQuery from '@hooks/useApiQuery';
import QueryKeys from '@src/constants/queryKeys';
import { Stack } from '@src/types/Stacks';

export default () =>
  useApiQuery<Stack>({
    queryKey: [QueryKeys['default-stack']],
    apiPath: '/default-stack',
    method: 'GET',
    useV2API: true,
  });
